// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-180[data-v-29058e1a]{width:120px}.dictionaryItems-panel[data-v-29058e1a]{max-height:300!important;overflow:auto}", ""]);
// Exports
module.exports = exports;
